import request from '@/utils/request'

export function payOrder (data) {
    return request({
        url: 'pay/wechatPay',
        method: 'GET',
        params: data
    })
}

export function payWechatJsApi (data) {
    return request({
        url: 'pay/wechatJsapi',
        method: 'GET',
        params: data
    })
}
